import {MinusCircleOutlined, PlusOutlined} from '@ant-design/icons';
import {Button, Col, Form, Row, Select} from 'antd';
import styles from '../../subscriptionSettings.module.scss';
import CatalogModalSection from '../catalogItemModal/CatalogModalSection';

const BundleItemsSection = ({
  planOptions,
  loadingCatalog,
  onPlanChange,
  onCatalogItemChange,
  getCatalogItemOptions,
}) => {
  return (
    <CatalogModalSection
      title="Bundle items"
      description="Add one or more bundle rows: plan + catalog item.">
      <Form.List name="itemSelections">
        {(fields, {add, remove}) => (
          <div className={styles['catalog-price-list']}>
            <div className={styles['catalog-price-list-header']}>
              <span>Bundle rows</span>
              <Button
                type="dashed"
                icon={<PlusOutlined />}
                onClick={() =>
                  add({
                    selectedPlanKey: undefined,
                    selectedCatalogKey: undefined,
                  })
                }>
                Add bundle row
              </Button>
            </div>

            {fields.map(field => (
              <div key={field.key} className={styles['catalog-price-row']}>
                <Row gutter={12} align="bottom">
                  <Col xs={24} md={11}>
                    <Form.Item
                      label="Plan"
                      name={[field.name, 'selectedPlanKey']}
                      rules={[{required: true, message: 'Plan required'}]}>
                      <Select
                        showSearch
                        optionFilterProp="label"
                        options={planOptions}
                        onChange={value => onPlanChange(field.name, value)}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={11}>
                    <Form.Item shouldUpdate noStyle>
                      {({getFieldValue}) => {
                        const rows = getFieldValue('itemSelections') || [];
                        const selectedPlanKey =
                          rows[field.name]?.selectedPlanKey;
                        const options = getCatalogItemOptions(selectedPlanKey);

                        return (
                          <Form.Item
                            label="Subscription"
                            name={[field.name, 'selectedCatalogKey']}
                            rules={[
                              {
                                required: true,
                                message: 'Subscription required',
                              },
                              {
                                validator: async (_, value) => {
                                  if (!value) {
                                    return;
                                  }

                                  const hasDuplicate = rows.some(
                                    (row, index) => {
                                      if (index === field.name) {
                                        return false;
                                      }
                                      return row?.selectedCatalogKey === value;
                                    },
                                  );

                                  if (hasDuplicate) {
                                    throw new Error(
                                      'This subscription already exists in bundle',
                                    );
                                  }
                                },
                              },
                            ]}>
                            <Select
                              showSearch
                              optionFilterProp="label"
                              options={options}
                              disabled={!selectedPlanKey}
                              loading={loadingCatalog}
                              onChange={value =>
                                onCatalogItemChange(field.name, value)
                              }
                            />
                          </Form.Item>
                        );
                      }}
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={2}>
                    <Form.Item
                      label=" "
                      className={styles['bundle-remove-field']}>
                      <Button
                        type="text"
                        danger
                        icon={<MinusCircleOutlined />}
                        disabled={fields.length <= 1}
                        onClick={() => remove(field.name)}
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </div>
            ))}
          </div>
        )}
      </Form.List>
    </CatalogModalSection>
  );
};

export default BundleItemsSection;
